import React from 'react'
import LineSeparator from '../../../../../packages/kiti/components/helpers/LineSeparator'
import { COLORS } from '@btime/constants'
import Separator from '../../../../../components/pdf/Separator'
import { MONTHS } from '../../constants/dates'
import { findReplyByQuestionId, getReplyValue } from '../../_helpers/pdfHelpers'
import { useServiceOrder } from '../../_load/ServiceOrderLoader'
import { Grid } from '../../../../../packages/kiti/components/structure/Grid'
import Image from '../../../../../components/pdf/Image'
import View from '../../../../../components/pdf/View'

const Content = () => {
  const { replies } = useServiceOrder()
  const question359 = findReplyByQuestionId(replies, 359)
  const question363 = findReplyByQuestionId(replies, 363)
  const question365 = findReplyByQuestionId(replies, 365)
  const question366 = findReplyByQuestionId(replies, 366)
  const question367 = findReplyByQuestionId(replies, 367)
  const question368 = findReplyByQuestionId(replies, 368)
  const question369 = findReplyByQuestionId(replies, 369)
  const question370 = findReplyByQuestionId(replies, 370)
  const question371 = findReplyByQuestionId(replies, 371)
  const question373 = findReplyByQuestionId(replies, 373)
  const question375 = findReplyByQuestionId(replies, 375)
  const question379 = findReplyByQuestionId(replies, 379)
  const question380 = findReplyByQuestionId(replies, 380)
  const question383 = findReplyByQuestionId(replies, 383)
  const question384 = findReplyByQuestionId(replies, 384)
  const question385 = findReplyByQuestionId(replies, 385)
  const question386 = findReplyByQuestionId(replies, 386)
  const question387 = findReplyByQuestionId(replies, 387)

  const currentMonth = new Date().getMonth()
  const currentYear = new Date().getFullYear()

  const chunkArray = (arr, size) => {
    const result = []
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size))
    }
    return result
  }

  const renderImages = documents => {
    if (!documents) return null
    const groups = chunkArray(documents, 3)

    return groups.map((group, idx) => (
      <div
        key={idx}
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '16px',
          marginTop: '15px',
          flexWrap: 'wrap'
        }}
      >
        {group.map(doc => (
          <div
            key={doc.src}
            style={{
              textAlign: 'center',
              maxWidth: '220px',
              boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
              overflow: 'hidden',
              backgroundColor: '#fff'
            }}
          >
            <Image
              src={doc.src}
              style={{
                height: '200px',
                width: '100%',
                objectFit: 'cover'
              }}
            />
            {doc?.description && (
              <div
                style={{
                  padding: '8px',
                  fontSize: '12pt',
                  textAlign: 'justify',
                  marginLeft: 0,
                  marginRight: 0,
                  textIndent: '1.25cm',
                  marginTop: 0,
                  marginBottom: '8pt',
                  lineHeight: 1.16,
                  borderTop: '1px solid #eee',
                  background: '#fafafa'
                }}
              >
                {doc.description}
              </div>
            )}
          </div>
        ))}
      </div>
    ))
  }

  return (
    <div
      style={{
        fontFamily: 'Arial, sans-serif',
        fontSize: '12pt',
        textAlign: 'justify',
        marginLeft: 0,
        marginRight: 0,
        marginTop: 0,
        marginBottom: '8pt',
        lineHeight: 1.16
      }}
    >
      {/* Gap 5 (pedido da Julia Buzzo, ver PR): capa isolada em pagina propria com
          <View pageBreakAfter> (mesma convencao de page-break CSS ja usada em
          pdfs/bradesco/pgr, ver components/pdf/View.js / 00.CoverSection.js), em vez de
          depender so da contagem de <br/> para empurrar o conteudo seguinte para a
          proxima pagina. Isso corrige a causa raiz do espaco em branco grande antes de
          "1. Introdução" relatado pela Julia: com @page { margin: 3cm 2cm 2cm 3cm }
          (round 3 de #761) a area util da pagina encolheu, e a contagem antiga de <br/>
          (calibrada para as margens anteriores) passou a sobrar/faltar. Com o
          page-break explicito, o bloco seguinte SEMPRE comeca no topo da proxima
          pagina, independente da contagem de <br/> usada aqui so para espacamento
          vertical dentro da propria pagina -- essa contagem residual foi removida no
          seguimento abaixo apos causar overflow de pagina. */}
      <View pageBreakAfter>
        <h2 style={{ textAlign: 'center', fontFamily: 'Arial, sans-serif', fontSize: '16pt' }}>
          RELATÓRIO DE MANUTENÇÃO PREVENTIVA - {MONTHS[currentMonth]?.toUpperCase()} - {currentYear} <br />
          SDAI (SISTEMA DE DETECÇÃO E ALARME DE INCÊNDIO) <br />
          SABIC – INNOVATIVE PLASTICS <br />
          CENTRAL – PRÉDIO RESINAS
        </h2>
      {/* Seguimento (2º report da Julia Buzzo, mesmo PR): removida a contagem residual
          de <br/> que ficava aqui como "estimativa conservadora" pos-#761. Combinada
          com o pageBreakAfter, ela empurrava o conteudo alem de uma pagina inteira e
          transbordava para uma pagina extra quase em branco antes da quebra forcada
          entrar em acao -- essa era a causa das paginas em branco no meio do
          documento. O pageBreakAfter sozinho ja garante que o proximo bloco comece
          no topo da proxima pagina; nenhum <br/> de preenchimento e necessario aqui. */}
      </View>
      <LineSeparator weight={4} color={COLORS.light3} padding={4} />
      <h3>1. Introdução</h3>
      {/* Gap 3: normalizado de textIndent:'2em' (e sem textAlign nenhum) para o mesmo
          espaçamento de parágrafo (justify + recuo de 1ª linha 1.25cm + margens +
          line-height) usado no restante do documento (ver seções 3-9 abaixo). */}
      <p
        style={{
          textAlign: 'justify',
          marginLeft: 0,
          marginRight: 0,
          textIndent: '1.25cm',
          marginTop: 0,
          marginBottom: '8pt',
          lineHeight: 1.16
        }}
      >
        Este Relatório tem como objetivo expressar as atividades realizadas pela empresa Easy Solutions, bem como
        substituição de dispositivos danificados, visando informar sempre as melhorias cabíveis ao sistema de acordo com
        a necessidade de cada cliente e atender a NBR 17240-2010 (Sistema de Detecção e Alarme de Incêndio, Projetos,
        Instalações e Manutenções do Sistema).
      </p>
      <View pageBreakBefore>
        <h3>2. Ferramentas utilizadas para Testar Detectores</h3>
      </View>
      {/* Gap 3: normalizado de textIndent:'2em' (e sem textAlign nenhum) para o mesmo
          espaçamento de parágrafo (justify + recuo de 1ª linha 1.25cm + margens +
          line-height) usado no restante do documento (ver seções 3-9 abaixo). */}
      <p
        style={{
          textAlign: 'justify',
          marginLeft: 0,
          marginRight: 0,
          textIndent: '1.25cm',
          marginTop: 0,
          marginBottom: '8pt',
          lineHeight: 1.16
        }}
      >
        A Easy Solutions possui o Kit para testar Detectores Térmico, utilizam Soprador Térmico, equipamentos que
        atendem as Normas Internacionais de Fire Alarm NBR-17240-2010, conforme figura abaixo.
      </p>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Image
          src="/pdfs/easysolutions/fire_alarm.png"
          maxHeight={'175px'}
          ignoreFixedSize
          alt="Figura 1 Alarme de Incendio"
        />
        <Image
          src="/pdfs/easysolutions/soprador_termico.png"
          maxHeight={'175px'}
          ignoreFixedSize
          alt="Figura 2 Soprador Térmico"
        />
      </div>
      <View pageBreakBefore>
        <h3>3. Serviços Realizados</h3>
      </View>
      <p
        style={{
          textAlign: 'justify',
          marginLeft: 0,
          marginRight: 0,
          textIndent: '1.25cm',
          marginTop: 0,
          marginBottom: '8pt',
          lineHeight: 1.16
        }}
      >{question359?.value || 'N/A'}</p>
      <Grid wrap gap={0.5} align="center" justify="center">
        {renderImages(question359?.documents)}
      </Grid>
      <p
        style={{
          textAlign: 'justify',
          marginLeft: 0,
          marginRight: 0,
          textIndent: '1.25cm',
          marginTop: 0,
          marginBottom: '8pt',
          lineHeight: 1.16
        }}
      >{[question363?.value, question365?.value].filter(Boolean).join(' e ')}</p>
      <Grid wrap gap={0.5} align="center" justify="center">
        {renderImages(question363?.documents)}
        {renderImages(question365?.documents)}
      </Grid>
      <p
        style={{
          textAlign: 'justify',
          marginLeft: 0,
          marginRight: 0,
          textIndent: '1.25cm',
          marginTop: 0,
          marginBottom: '8pt',
          lineHeight: 1.16
        }}
      >{question366?.value || 'N/A'}</p>
      <Grid wrap gap={0.5} align="center" justify="center">
        {renderImages(question366?.documents)}
      </Grid>
      <p
        style={{
          textAlign: 'justify',
          marginLeft: 0,
          marginRight: 0,
          textIndent: '1.25cm',
          marginTop: 0,
          marginBottom: '8pt',
          lineHeight: 1.16
        }}
      >{question367?.value || 'N/A'}</p>
      <Grid gap={0.5} align="center" justify="center">
        {renderImages(question367?.documents)}
      </Grid>

      <View pageBreakBefore>
        <h3>4. Tensão da Central de Incêndio</h3>
      </View>
      <p
        style={{
          textAlign: 'justify',
          marginLeft: 0,
          marginRight: 0,
          textIndent: '1.25cm',
          marginTop: 0,
          marginBottom: '8pt',
          lineHeight: 1.16
        }}
      >
        {question368?.value?.split('\n').map((line, idx) => (
          <React.Fragment key={idx}>
            {line}
            <br />
          </React.Fragment>
        ))}
      </p>
      <Grid wrap gap={0.5} align="center" justify="center">
        {renderImages(question368?.documents)}
      </Grid>

      <View pageBreakBefore>
        <h3>5. Teste do Sistema</h3>
      </View>
      <p
        style={{
          textAlign: 'justify',
          marginLeft: 0,
          marginRight: 0,
          textIndent: '1.25cm',
          marginTop: 0,
          marginBottom: '8pt',
          lineHeight: 1.16
        }}
      >{question369?.value || 'N/A'}</p>
      <Grid wrap gap={0.5} align="center" justify="center">
        {renderImages(question369?.documents)}
      </Grid>

      <View pageBreakBefore>
        <h3>6. </h3>
      </View>
      <p
        style={{
          textAlign: 'justify',
          marginLeft: 0,
          marginRight: 0,
          textIndent: '1.25cm',
          marginTop: 0,
          marginBottom: '8pt',
          lineHeight: 1.16
        }}
      >{question370?.value || 'N/A'}</p>
      <Grid wrap gap={0.5} align="center" justify="center">
        {renderImages(question370?.documents)}
      </Grid>

      <p
        style={{
          textAlign: 'justify',
          marginLeft: 0,
          marginRight: 0,
          textIndent: '1.25cm',
          marginTop: 0,
          marginBottom: '8pt',
          lineHeight: 1.16
        }}
      >{question373?.value || 'N/A'}</p>
      <Grid wrap gap={0.5} align="center" justify="center">
        {renderImages(question373?.documents)}
      </Grid>

      <p
        style={{
          textAlign: 'justify',
          marginLeft: 0,
          marginRight: 0,
          textIndent: '1.25cm',
          marginTop: 0,
          marginBottom: '8pt',
          lineHeight: 1.16
        }}
      >{question375?.value || 'N/A'}</p>
      <Grid wrap gap={0.5} align="center" justify="center">
        {renderImages(question375?.documents)}
      </Grid>

      <p
        style={{
          textAlign: 'justify',
          marginLeft: 0,
          marginRight: 0,
          textIndent: '1.25cm',
          marginTop: 0,
          marginBottom: '8pt',
          lineHeight: 1.16
        }}
      >{[question379?.value, question380?.value].filter(Boolean).join(' e ')}</p>
      <Grid wrap gap={0.5} align="center" justify="center">
        {renderImages(question379?.documents)}
        {renderImages(question380?.documents)}
      </Grid>

      <View pageBreakBefore>
        <h3>7. Status do sistema de supressão por CO2 ao sair</h3>
      </View>

      <p
        style={{
          textAlign: 'justify',
          marginLeft: 0,
          marginRight: 0,
          textIndent: '1.25cm',
          marginTop: 0,
          marginBottom: '8pt',
          lineHeight: 1.16
        }}
      >{question371?.value || 'N/A'}</p>
      <Grid wrap gap={0.5} align="center" justify="center">
        {renderImages(question371?.documents)}
      </Grid>

      <p
        style={{
          textAlign: 'justify',
          marginLeft: 0,
          marginRight: 0,
          textIndent: '1.25cm',
          marginTop: 0,
          marginBottom: '8pt',
          lineHeight: 1.16
        }}
      >{question383?.value || 'N/A'}</p>
      <Grid wrap gap={0.5} align="center" justify="center">
        {renderImages(question383?.documents)}
      </Grid>

      <p
        style={{
          textAlign: 'justify',
          marginLeft: 0,
          marginRight: 0,
          textIndent: '1.25cm',
          marginTop: 0,
          marginBottom: '8pt',
          lineHeight: 1.16
        }}
      >{question384?.value || 'N/A'}</p>
      <Grid wrap gap={0.5} align="center" justify="center">
        {renderImages(question384?.documents)}
      </Grid>

      <p
        style={{
          textAlign: 'justify',
          marginLeft: 0,
          marginRight: 0,
          textIndent: '1.25cm',
          marginTop: 0,
          marginBottom: '8pt',
          lineHeight: 1.16
        }}
      >{question385?.value || 'N/A'}</p>
      <Grid wrap gap={0.5} align="center" justify="center">
        {renderImages(question385?.documents)}
      </Grid>

      <View pageBreakBefore>
        <h3>8. Melhoria no sistema</h3>
      </View>

      <p
        style={{
          textAlign: 'justify',
          marginLeft: 0,
          marginRight: 0,
          textIndent: '1.25cm',
          marginTop: 0,
          marginBottom: '8pt',
          lineHeight: 1.16
        }}
      >{question386?.value || 'N/A'}</p>
      <Grid wrap gap={0.5} align="center" justify="center">
        {renderImages(question386?.documents)}
      </Grid>

      <View pageBreakBefore>
        <h3>9. Conclusão</h3>
      </View>

      <p
        style={{
          textAlign: 'justify',
          marginLeft: 0,
          marginRight: 0,
          textIndent: '1.25cm',
          marginTop: 0,
          marginBottom: '8pt',
          lineHeight: 1.16
        }}
      >{question387?.value || 'N/A'}</p>
      <Grid wrap gap={0.5} align="center" justify="center">
        {renderImages(question387?.documents)}
      </Grid>
      <Separator weight={5} />
    </div>
  )
}

export default Content
